﻿<template>
  <ul id="nav-share" class="nav-share" style="bottom: 100px;right: 80px;">
    <li class="s-phone"><a href="javascript:;"></a>
      <div class="s-phone-hover"><p class="sph-t">客服热线（9:00-21:00）</p>
        <p class="sph-p">13919392393</p></div>
    </li>
    <li class="s-wechat"><a href="javascript:;"></a>
      <div class="s-wechat-hover"><img width="100%" height="100%" src="/images/keyCode.jpg"
                                       alt="wechat"></div>
    </li>
    <li class="s-wechat-mini">
      <a href="javascript:;"></a>
      <div class="s-wechat-mini-hover"><img width="100%" height="100%" src="/images/littlecode.jpg"
                                       alt="wechat"></div>
    </li>
    <li class="s-backtop" v-if="d_backtopshow"><a href="javascript:;" @click="backtopreturn"
                                                  class="icon-kaistart-backtotop"></a></li>
  </ul>
</template>
<script>
  export default {
    data() {
      return {
        d_backtopshow: false,
      }
    },
    methods: {
      scrollshare: function () {
        var t = this
        if (document.documentElement.scrollTop >= document.documentElement.clientHeight) {
          t.d_backtopshow = true
        } else {
          t.d_backtopshow = false
        }

      },
      backtopreturn: function () {
        var currentPosition = document.documentElement.scrollTop || document.body.scrollTop;
        var timer = setInterval(function () {
          currentPosition -= 10;
          if (currentPosition > 0) {
            window.scrollTo(0, currentPosition);
          }
          else {
            window.scrollTo(0, 0);
            clearInterval(timer);
          }
        }, .5);
      },
    },
    mounted() {
      window.addEventListener("scroll", this.scrollshare);
    }

  }
</script>

